/**
 * Target guards for gesture start gating: resolve a gesture `EventTarget` to an
 * element so the recognizer can decide whether a drag should engage. Pure DOM
 * predicate — no Solid, no recognizer.
 */

function asElement(target: EventTarget | null): Element | null {
  if (target instanceof Text) {
    return target.parentElement;
  }
  return target instanceof Element ? target : null;
}

/** True if `target` (or an ancestor) matches `selector`. */
export function closestSelector(target: EventTarget | null, selector: string): boolean {
  const el = asElement(target);
  return Boolean(el?.closest(selector));
}
